"use strict";

var _toConsumableArray = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-peg-playground/react-peg-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = void 0;

var chunk_1 = require("../chunk/chunk");

var rule_1 = require("../translator/rule/rule");

var peg = require("pegjs");

var Renderer = /*#__PURE__*/function () {
  function Renderer(chunk) {
    _classCallCheck(this, Renderer);

    this.tracer = null;
    this.initializer = "\n            {\n                const { actions } = options;\n                const globalFunction = {\n                    location,\n                    text\n                };\n            }\n        ";
    this.start = chunk;
    this.grammar = new Map();
    this.grammar.set("initializer", this.initializer);
    this.rules = new Map();
    this.actions = new Map();
  }

  _createClass(Renderer, [{
    key: "render",
    value: function render() {
      this.collectRule(this.start);

      var grammar = _toConsumableArray(this.grammar.values()).join("\n\n");

      return grammar;
    }
  }, {
    key: "collectRule",
    value: function collectRule(chunk) {
      var _this = this;

      if (!chunk_1.isChunk(chunk)) {
        return;
      }

      if (chunk.rule) {
        var translator = new rule_1.RuleTranslator();
        var ruleStr = translator.translate(chunk, this.actions);
        var _translator$cache = translator.cache,
            name = _translator$cache.name,
            chunkOutput = _translator$cache.chunkOutput,
            rule = _translator$cache.rule;

        if (this.rules.has(name)) {
          return;
        }

        this.rules.set(name, rule);
        this.grammar.set(name, ruleStr);
        this.collectRule(chunkOutput);
      }

      chunk.children.forEach(function (child) {
        _this.collectRule(child);
      });
    }
  }]);

  return Renderer;
}();

var Parser = /*#__PURE__*/function () {
  function Parser(renderer) {
    _classCallCheck(this, Parser);

    this.renderer = renderer;
    this.grammar = this.renderer.render();
    this.parser = peg.generate(this.grammar, {
      trace: Boolean(renderer.tracer)
    });
  }

  _createClass(Parser, [{
    key: "parse",
    value: function parse(code) {
      try {
        var options = {
          actions: this.renderer.actions
        };

        if (this.renderer.tracer) {
          /**
           * Tracing with peg.js: https://gist.github.com/mistlog/3ac6fdf7de3e7af2da15b339b4bb5187
           */
          options.tracer = this.renderer.tracer;
        }

        var ast = this.parser.parse(code, options);
        return ast;
      } catch (error) {
        throw {
          message: error.message,
          location: error.location,
          stack: error.stack
        };
      }
    }
  }]);

  return Parser;
}();

function render(chunk) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var renderer = new Renderer(chunk);

  if (config.tracer) {
    renderer.tracer = config.tracer;
  }

  var parser = new Parser(renderer);
  return parser;
}

exports.render = render;